module.exports = __webpack_public_path__ + "static/media/heatmap.eda64755.svg";